import {
  CompanyName,
  Container,
  JobDescContainer,
  JobDescription,
} from "./style";

interface IExperienceCardProps {
  company: string;
  position: string;
  startDate: string;
  endDate?: string;
  isCurrent?: boolean;
}

function ExperienceCard({
  company,
  position,
  startDate,
  endDate,
  isCurrent,
}: IExperienceCardProps) {
  return (
    <Container>
      <CompanyName>{company}</CompanyName>
      <JobDescContainer>
        <JobDescription>{position}</JobDescription>
        <JobDescription>&#x2022;</JobDescription>
        <JobDescription>{`${startDate} - ${isCurrent ? "Present" : endDate}`}</JobDescription>
      </JobDescContainer>
    </Container>
  );
}

export default ExperienceCard;
